import {CompositeMonorailEvent} from '@shopify/monorail/lib/events/events';
import {
  Middleware,
  MiddlewareChainFn,
  MonorailRequestError,
} from '@shopify/monorail';

export class IgnoreErrorMiddleware implements Middleware {
  async do(event: CompositeMonorailEvent, proceed: MiddlewareChainFn) {
    try {
      return await proceed(event);
    } catch (error) {
      if (error instanceof MonorailRequestError) {
        return Promise.resolve({status: 200});
      } else throw error;
    }
  }
}
